import {
  Text,
  BorderRadius4,
  BorderRadius6,
  GreyGrey10,
  GreyGrey80,
  Primary13Regular,
  ShadowL,
  Box,
  Flex
} from '@sequencehq/core-components'
import { InvoiceRenderer } from 'Invoices/components/CreateEditShared'

export const SendInvoiceModalBody = () => (
  <Flex gap="16px" flexDir="column">
    <Text {...Primary13Regular} color={GreyGrey80}>
      After sending you can no longer edit the invoice.
    </Text>

    <Box
      width="100%"
      height="306px"
      borderRadius={BorderRadius6}
      overflow="hidden"
      background={GreyGrey10}
      padding="24px"
    >
      <Box
        overflow="hidden"
        borderRadius={BorderRadius4}
        boxShadow={ShadowL}
        border="rgba(0, 0, 0, 0.08) 1px solid"
      >
        <InvoiceRenderer width={334} showSkeletons={false} />
      </Box>
    </Box>
  </Flex>
)
